import * as React from "react";
import { Grid, Link, Typography } from "@mui/material";
import { AppBody } from "../AppBody";
import Breadcrumbs from "../../containers/Breadcrumbs";
import { appHeaderTitle } from "../../common/services/Utilities";
import { useInitialPageLoad } from "../../hooks/useInitialPageLoad";
import { useNavigate, Link as RouterLink, useLocation } from "react-router-dom";
import { AppUrl } from "../../config";
import CloudFoundryBanner from "../../containers/CloudFoundryBanner";
import FRIconStatic from "../../common/assets/images/FinancialReporting_Static.svg";
import FRIconHover from "../../common/assets/images/FinancialReporting_Focus.svg";
import StandardIconStatic from "../../common/assets/images/StandarComparisons_Static.svg";
import StandardIconHover from "../../common/assets/images/StandarComparisons_Focus.svg";
import CustomizedStatic from "../../common/assets/images/CustomComparisons_Static.svg";
import CustomizedHover from "../../common/assets/images/CustomComparisons_Focus.svg";
import ManagePGStatic from "../../common/assets/images/SavePeersReports_Static.svg";
import ManagePGHover from "../../common/assets/images/SavePeersReports_foucs.svg";
import { LevelTwoAppCard, LevelTwoAppCardProps } from "../LevelTwoAppCard";

export default function FinancialReporting() {
  const navigate = useNavigate();
  const location = useLocation();

  useInitialPageLoad("financials");

  const introParagraph = (
    <>
      {appHeaderTitle("financials")}
      <Typography variant="body2" id="financial-reporting-description">
        Create comprehensive financial reports of single institutions and peer
        groups using quarterly data since 1992. Use our predefined options of
        reports and standard peer groups, or create your own library of reusable
        customized tools to research the subjects and data tailored to your
        interests (saving custom content requires logging in with a login.gov
        account.)
      </Typography>
      <Typography variant="body2" id="financial-reporting-tutorials">
        If you need assistance, please see the{" "}
        <RouterLink to={"/help?helpTopic=tutorials"}>Help Section</RouterLink>{" "}
        for tutorials to get you started.
      </Typography>
      <Typography variant="body2" id="peer-group-feedback-link">
        Provide{" "}
        <Link
          href={
            "https://ask.fdic.gov/fdicinformationandsupportcenter/s/fdicdirform?app=FinRegData"
          }
        >
          feedback or submit a question
        </Link>{" "}
        about this page.
      </Typography>
    </>
  );

  const financialReportApps: LevelTwoAppCardProps[] = [
    {
      id: "financialReporting",
      iconStatic: FRIconStatic,
      iconHover: FRIconHover,
      title: (
        <>
          Financial/Regulatory
          <br />
          Search & Reporting
        </>
      ),
      alt: "Financial/Regulatory Search & Reporting",
      onClick: () => navigate(`${AppUrl("FinancialReporting")}/report`),
    },
    {
      id: "pgcStandard",
      iconStatic: StandardIconStatic,
      iconHover: StandardIconHover,
      title: <>Standard Comparisons</>,
      alt: "Standard Comparisons",
      onClick: () => navigate(`${AppUrl("PeerGroup")}/standard`),
    },
    {
      id: "pgcCustomized",
      iconStatic: CustomizedStatic,
      iconHover: CustomizedHover,
      title: <>Customized Comparisons</>,
      alt: "Customized Comparisons",
      onClick: () =>
        navigate(`/peergroup/customized`, {
          state: {
            url: `${location.pathname}${location.search}`,
          },
        }),
    },
    {
      id: "pgcManageSavedPeerGroups",
      iconStatic: ManagePGStatic,
      iconHover: ManagePGHover,
      title: (
        <>
          Manage Your Saved
          <br />
          Custom Content
        </>
      ),
      alt: "Manage Your Saved Custom Content",
      onClick: () =>
        navigate(
          {
            pathname: `${AppUrl("PeerGroup")}/manage`,
            search: "?tab=Custom Financial Reports",
          },
          {
            state: {
              url: AppUrl("FinancialReporting") + window.location.search,
              history: "FR",
            },
          },
        ),
    },
  ];

  return (
    <>
      <Grid container spacing={2}>
        <Grid size={12}>
          <Breadcrumbs currentPageBreadCrumbTitle="Reports and Comparisons" />
        </Grid>
      </Grid>
      <CloudFoundryBanner />
      <AppBody introText={introParagraph} login>
        <Grid
          container
          spacing={2}
          sx={{ py: 3, maxWidth: 1200, mx: "auto", width: "100%" }}
        >
          {financialReportApps.map((app) => (
            <Grid
              key={app.id}
              size={{
                xs: 12,
                md: 3,
              }}
            >
              <LevelTwoAppCard {...app} />
            </Grid>
          ))}
        </Grid>
      </AppBody>
    </>
  );
}
